









































import { PaginationSyncDTO, ResultPagDTO } from '@/interfaces/base-dto';
import { PendenciaPrescricaoFiltroDTO } from '@/interfaces/pending-prescriptions';
import * as service from '@/services/pending-prescriptions';
import { isProduction } from '@/services/utils';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '../base-component.vue';
import ListMessages from '../UI/list-messages.vue';
import PermissionAuth from '../UI/permission-auth.vue';
import PendingPrescriptionHistoryDetailsButton from './pending-prescription-hist-details-button.vue';
import PendingPrescriptionStatusChip from './pending-prescription-status-chip.vue';

@Component({
  components: {
    ListMessages,
    PermissionAuth,
    PendingPrescriptionStatusChip,
    PendingPrescriptionHistoryDetailsButton
  }
})
export default class PendingPrescriptionTable extends BaseComponent {
  @Prop()
  public filtros: PendenciaPrescricaoFiltroDTO;


  @Prop({default: false})
  public silent: boolean;

  @Prop({default: false})
  public btnWhatsapp: boolean;

  private error: boolean = false;
  private loading: boolean = false;
  private items: any[] = [];
  private production = false;

  public headers: any = [
    { text: 'Data', value: 'dataPendencia', sortable: true },
    { text: 'Unidade', value: 'uni.nome', sortable: true },
    { text: 'Médico', value: 'prescricaoGatilho.medico.nome', sortable: true },
    { text: 'Paciente', value: 'pac.nome', sortable: true },
    { text: 'Horário Limite', value: 'horaLimitePrescricao', align: 'center', sortable: true },
    { text: 'Status', value: 'status', sortable: true },
    { text: 'Tentativas', value: 'tentativas', align: 'center', sortable: true },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false }
  ];

  private pagination: PaginationSyncDTO = new PaginationSyncDTO();
  public pagina: ResultPagDTO<any> = new ResultPagDTO();

  mounted() {
    this.registerLoadSubject();
    isProduction().subscribe(r => {
      this.production = r;
    })
  }

  changePagination = false;
  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  @Watch('pagination.sortBy')
  @Watch('pagination.descending')
  private onChangePagination() {
    this.changePagination = true;
    this.search();
  }

  @Watch('filtros', { immediate: true })
  private onChangeSearch() {
    PaginationSyncDTO.updateSortProperties(this.pagination, this.filtros);
    this.pagination.page = 1;
    this.search();
  }

  private search() {
    this.loadSubject$.next(this.filtros);
  }

  loadSubject$ = new BehaviorSubject(null);

  public registerLoadSubject() {
    this.loadSubject$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(100),
        switchMap((filter) => {
          this.error = false;
          this.loading = !this.silent || this.changePagination;
          filter.update(this.pagination);
          return service.findPendingPrescriptionsByFilters(filter);
        })
      )
      .subscribe(
        (result) => {
          this.loading = false;
          this.changePagination = false;
          this.pagina = result;
          this.items = this.pagina.content;
          PaginationSyncDTO.update(this.pagination, result);
          this.$emit('listChange', result);
        },
        (error) => {
          this.loading = false;
          this.error = true;
        }
      );
  }

  private onEditItem(item) {
    this.$emit('idChange', item.id);
  }

  private onSendWhatsappItem(item) {
    this.$emit('whatsapp', item);
  }
}
